import styled from '@emotion/styled'
import { Row, Col } from 'components/patterns'
import { themeColor } from 'utils/styles'

export const StyledRow = styled(Row)`
  align-items: flex-start;
  height: 100%;
`

export const ConflictDetailsContainer = styled.div`
  padding: 15px 0;
`

export const StyledContainerDiv = styled.div`
  align-content: center;
  height: 480px;
  justify-content: center;
  display: flex;
  align-items: center;
`

export const ConflictTableCol = styled(Col)`
  height: 100%;
  background-color: ${themeColor('modalGrey')};
`

export const ConflictDetailsCol = styled(Col)`
  height: 100%;
  border-left: 1px solid ${themeColor('greySecondary')};
`
